import React from "react";
import GoogleMapMarker from "../Common/GoogleMapMarker";
import PropTypes from "prop-types";

const LocationComponent = (props = {}) => {
  const { messageObject = {} } = props;
  const {
    msgBody: { location: { latitude = null, longitude = null } = {} } = {}
  } = messageObject;
  return <GoogleMapMarker latitude={latitude} longitude={longitude} />;
};

export default LocationComponent;

LocationComponent.propTypes = {
  messageObject: PropTypes.shape({
    msgBody: PropTypes.shape({
      location: PropTypes.shape({
        latitude: PropTypes.number,
        longitude: PropTypes.number
      })
    })
  })
};
